import * as React from "react";
import RedDeBicicleteriasContainer from "../containers/red-de-bicicleterias-container";

export default function RedDeBicicleteriasPage() {
  return <RedDeBicicleteriasContainer></RedDeBicicleteriasContainer>;
}
